"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCard = void 0;
const react_1 = __importDefault(require("react"));
require("./price-card.css");
;
;
;
/**
 * Main component.
 * @name priceCard
 * @param {PriceCardProps}
 * @returns {<PriceCard />}
*/
const PriceCard = ({ info, style = undefined }) => {
    var _a;
    //Setting default styles
    let custmStyle = (style ? style : {});
    if (((_a = custmStyle === null || custmStyle === void 0 ? void 0 : custmStyle.backgroundImage) === null || _a === void 0 ? void 0 : _a.indexOf('url(')) === -1) {
        custmStyle.backgroundImage = `url('${custmStyle.backgroundImage}')`;
    }
    return (react_1.default.createElement("div", { className: "pricecard-container", "data-testid": "pricecard-element", style: custmStyle },
        react_1.default.createElement("div", { className: "pricecard-title" },
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: info.title } })),
        react_1.default.createElement("div", { className: "pricecard-info" },
            react_1.default.createElement("p", { className: "quote-desc", dangerouslySetInnerHTML: { __html: info.quoteDesc } }),
            react_1.default.createElement("p", { className: "pricecard-number" },
                "$",
                info.price)),
        react_1.default.createElement("div", { className: "pricecard-mobile" },
            info.logo && (react_1.default.createElement("img", { src: info.logo })),
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: info.mobileText } }))));
};
exports.PriceCard = PriceCard;
//# sourceMappingURL=price-card.js.map